import { useMatrixSettingsContext } from '@app/components/products/ProductMatrix/context';
import { CancelSmall } from '@app/components/various/Icons';
import { VariantBodyCells } from '@app/components/various/Matrix/MatrixBody/VariantBodyCells';
import { RegularBodyCell } from '@app/components/various/Matrix/MatrixCells/RegularBodyCell';
import { useMatrixLayout } from '@app/utils/hooks/matrix/useMatrixLayout';
import { isDefined } from '@app/utils/is';

import { Item, Product } from '../../../../../../typings';

interface Props {
  rowIndex: number;
  rowVariant: Product.Standard;
  rowItems: (Item | undefined)[];
}

export const LookbookMatrixRow = ({ rowIndex, rowVariant, rowItems }: Props) => {
  const { isDesktop } = useMatrixSettingsContext();
  const { isTwoDimensional } = useMatrixLayout();

  const isFirstRow = rowIndex === 0;
  const shouldShowHeadings = isDesktop && (!isTwoDimensional || isFirstRow);
  const headingsRowSpan = !isTwoDimensional ? undefined : rowVariant.itemTable.y.length;

  return (
    <tr>
      {shouldShowHeadings && <VariantBodyCells variant={rowVariant} rowIndex={rowIndex} rowSpan={headingsRowSpan} />}
      {rowItems.map((item, index) =>
        isDefined(item) ?
          <RegularBodyCell key={item.item} innerClassName="hover:border-transparent px-1">
            <span className="whitespace-nowrap text-neutral-40 body-6">{item.name}</span>
          </RegularBodyCell>
        : <RegularBodyCell key={index} innerClassName="hover:border-transparent">
            <CancelSmall className="text-neutral-40" />
          </RegularBodyCell>,
      )}
    </tr>
  );
};
